export default {
      id: "social-medium-usage",
      viewBox: "0 0 22 17",
      url: __webpack_public_path__ + "sprite.svg#social-medium",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/social-medium.svg
// module id = 138
// module chunks = 241 242 243